module.exports = __webpack_public_path__ + "static/img/Frame 1312318390@2x(7).09d5eee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Frame 1312318390@2x(7).png
// module id = E362
// module chunks = 1